document.addEventListener('DOMContentLoaded', () => {
  /** @type {readonly string[]} */
  const selectors = Object.freeze([
    '#shopify-pc__banner',
    '.shopify-privacy-banner',
    '.cc-window',
    '#cookie-consent-banner',
    '[aria-label="Cookie consent"]' // accessible fallback
  ]);

  /** @type {HTMLElement | null} */
  let banner = null;

  /**
   * @param {MutationRecord[]} mutations
   * @returns {void}
   */
  const observer = new MutationObserver((mutations) => {
    for (const selector of selectors) {
      /** @type {Element | null} */
      const found = document.querySelector(selector);
      if (found instanceof HTMLElement) {
        banner = found;
        initBanner(banner);
        observer.disconnect();
        break;
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Check immediately in case it's already there
  for (const selector of selectors) {
    /** @type {Element | null} */
    const found = document.querySelector(selector);
    if (found instanceof HTMLElement) {
      banner = found;
      initBanner(banner);
      observer.disconnect();
      break;
    }
  }

  /**
   * @param {HTMLElement} element
   * @returns {void}
   */
  function initBanner(element) {
    // Layout push-up removed for corner widget design

    /**
     * @returns {void}
     */
    const customizeButton = () => {
      /** @type {NodeListOf<Element>} */
      const buttons = element.querySelectorAll('button, a, .cc-btn');
      /** @type {HTMLElement | null} */
      let preferencesButton = null;
      
      // First pass: find and customize preferences button
      buttons.forEach((btn) => {
        if (!(btn instanceof HTMLElement)) return;
        /** @type {string} */
        const text = (btn.textContent?.trim().toLowerCase() || '');
        
        // Handle preferences button - replace with logo only (no cog)
        if (text.includes('manage preferences') || text === 'manage' || text === 'preferences') {
          preferencesButton = btn;
          // Get shop URL for logo
          /** @type {string} */
          const logoUrl = `${window.location.origin}/cdn/shop/files/logo.png?height=200&v=1763545038`;
          
          // Replace text with logo only (no cog icon)
          btn.innerHTML = `
            <img src="${logoUrl}" alt="" class="cookie-logo" aria-hidden="true">
          `;
          btn.setAttribute('aria-label', 'Manage cookie preferences');
          btn.classList.add('custom-preferences-link');
        }
      });
      
      // Second pass: handle decline button (now we have preferencesButton reference)
      buttons.forEach((btn) => {
        if (!(btn instanceof HTMLElement)) return;
        
        /** @type {string} */
        const text = (btn.textContent?.trim().toLowerCase() || '');
        
        // Handle decline button - change to "Review" and make it open preferences
        if (text === 'decline' || text.includes('decline')) {
          btn.textContent = 'Review';
          btn.classList.add('custom-review-button');
          
          // Make Review button trigger preferences panel
          /**
           * @param {MouseEvent} e
           * @returns {void}
           */
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            // Try to find preferences button (in case it wasn't found in first pass)
            /** @type {Element | null} */
            const prefBtn = preferencesButton || 
              element.querySelector('.custom-preferences-link, [aria-label*="preference" i], [aria-label*="manage" i]');
            
            if (prefBtn instanceof HTMLElement) {
              prefBtn.click();
            }
          });
        }
      });
    };

    // Run immediately
    customizeButton();

    // Watch for changes in the banner content
    /**
     * @returns {void}
     */
    const contentObserver = new MutationObserver(() => {
        customizeButton();
    });
    contentObserver.observe(element, { childList: true, subtree: true, characterData: true });
  }

  /**
   * @param {HTMLElement} element
   * @returns {void}
   */
  function updateLayout(element) {
     // No-op
  }

  /**
   * @returns {void}
   */
  function resetLayout() {
    document.body.style.paddingBottom = '';
  }
});

